import { Component, OnInit } from '@angular/core';
import { UtilityService } from 'bbsf-utilities';
import { PageInfoService } from '../../_metronic/core/services/page-info.service';
import { InjectedModule } from './../shared/models/InjectedModuleModel/InjectedModule';
import { injectionModuleService } from './../shared/Services/injectionModuleService.service';
import { FormGroup } from '@angular/forms';
import { ControlLayout, InputType, TextBoxOptions ,FilterItem } from 'bbsf-controls';

@Component({
  selector: 'lib-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  searchTextBox: TextBoxOptions;
  HomeSearch = new FormGroup({});
  TextInputFilter: FilterItem;
  searchText: '';
  routes:InjectedModule[]=[]

   cards: any [] = [
    {
     title:this.utilityService.getResourceValue("Users"),
     img: "./src/assets/images/menu/user.svg",
     link: "/Admin/Users"
   },
   {
     title: this.utilityService.getResourceValue("ActiveDirectory"),
     img: "./src/assets/images/menu/Folder.svg",
     link: "/Admin/ADConnection"
   },
   {
     title:this. utilityService.getResourceValue("Configuration"),
     img: "./src/assets/images/menu/Tools.svg",
     link: "/Admin/Configurations"
   },
   {
     title: this.utilityService.getResourceValue("Jobs"),
     img: "./src/assets/images/menu/Briefcase.svg",
     link: "/Admin/Jobs"
   },
   {
    title:this.utilityService.getResourceValue("License"),
    img: "./src/assets/images/menu/License.svg",
    link: "/Admin/License"
  },
  {
    title: this.utilityService.getResourceValue("Localization"),
    img: "./src/assets/images/menu/Localization.svg",
    link: "/Admin/Localization"
  },
  {
    title:this. utilityService.getResourceValue("Logs"),
    img: "./src/assets/images/menu/File.svg",
    link: "/Admin/Logs"
  },
  {
    title: this.utilityService.getResourceValue("ServiceProviders"),
    img: "./src/assets/images/menu/ServiceProvider.svg",
    link: "/Admin/Providers"
  },
  {
    title: this.utilityService.getResourceValue("PublicHolidays"),
    img: "./src/assets/images/menu/PublicHolidays.svg",
    link: "/Admin/PublicHolidays"
  },
  {
    title: this.utilityService.getResourceValue("Workflows"),
    img: "./src/assets/images/menu/Workflows.svg",
    link: "/Admin/Workflows"
  },
  {
    title: this.utilityService.getResourceValue("PermissionSets"),
    img: "./src/assets/images/menu/Locked-folder.svg",
    link: "/Admin/Roles/PermissionSets"
  },
  {
    title: this.utilityService.getResourceValue("Templates"),
    img: "./src/assets/images/menu/Templates.svg",
    link: "/Admin/Notifications/Templates"
  },
  {
    title: this.utilityService.getResourceValue("EmailHeader&FooterTemplates"),
    img: "./src/assets/images/menu/Mail.svg",
    link: "/Admin/Notifications/MasterLayouts"
  },
  {
    title: this.utilityService.getResourceValue("Lookup"),
    img: "./src/assets/images/menu/Lookups.svg",
    link: "/Admin/Lookups/Lookups"
  },
  {
    title: this.utilityService.getResourceValue("LookupGroups"),
    img: "./src/assets/images/menu/Lookup-group.svg",
    link: "/Admin/Lookups/LookupGroups"
  },
  {
    title: this.utilityService.getResourceValue("ImpersonationRules"),
    img: "./src/assets/images/menu/Impersonation.svg",
    link: "/Admin/ImpersonationRules"
  },
  {
    title: this.utilityService.getResourceValue("Departments"),
    img: "./src/assets/images/menu/Department.svg",
    link: "/Admin/Departments"
  },
  {
    title: this.utilityService.getResourceValue("Sectors"),
    img: "./src/assets/images/menu/Sectors.svg",
    link: "/Admin/Sectors"
  },
  {
    title: this.utilityService.getResourceValue("FAQs"),
    img: "./src/assets/images/menu/HelpCenter.svg",
    link: "/Admin/HelpCenter"
  },
 ];
  constructor(
    public utilityService:UtilityService,
    ) {
    this.routes=injectionModuleService.InjectedModules;
    PageInfoService.PageTitle=""
    PageInfoService.PageBreadcrumbs=[];
  }

  ngOnInit() {
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true;
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.ViewType = ControlLayout.Vertical
    this.searchTextBox.AutoComplete = "off"
    this.searchTextBox.Placeholder = "search"

    PageInfoService.PageTitle = this.utilityService.getResourceValue("Home")

  }


}
